import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Do Not Sell or Share My Personal Info',
  description: 'Opt-out and ensure your data remains protected under our "Do Not Sell" policy.',
  keywords: ['do not sell'],
  path: '/privacy/data',
}

export const PrivacyMetaData = generateMetadata(MetaData)
